export default {
  homeHeroLogo: 'HomeHero__logo',
  whyWeInvestStatisticsModule: 'opportunity',
  whyWeInvestHero: 'WhyWeInvestHero',
  companyDetailLanding: 'CompanyDetailLanding',
  heroImageModule: 'HeroImageModule',
};
